import React, { useState } from 'react';
import {
    Wrapper,
    Title,
} from "../../Views/CommonStyles";
import {
    ChartContainer,
    Item
} from "./styles";
import Col from '../../Shared/Kit/Col';
import Header from '../../Shared/Header';
import routPath from "../../Routes/NameSpace";
import ArrowLeftIcon from '../../Assets/Icons/ArrowLeftIcon';

const itemConfig = [
    {
        id: 1,
        title: "بورسی",
        sub: [
            {
                id: 1,
                title: "فلزات",
                sub: []
            },
            {
                id: 2,
                title: "صنعتی",
                sub: []
            },
            {
                id: 3,
                title: "دارویی",
                sub: []
            },
            {
                id: 4,
                title: "غذایی",
                sub: []
            }
        ]
    },
    {
        id: 2,
        title: "غیربورسی",
        sub: [
            {
                id: 1,
                title: "ساختمانی",
                sub: [
                    {
                        id: 1,
                        title: "منطقه 22 تهران"
                    }
                ]
            },
            {
                id: 2,
                title: "کشاورزی",
                sub: []
            },
            {
                id: 3,
                title: "صنعتی",
                sub: []
            }
        ]
    }
]

const Investment = () => {
    const [selected, setSelected] = useState(1)
    const [selected_sub, setSelected_sub] = useState(1)

    return (
        <Wrapper className="white-bg">
            <Header headerColor={"white"} />
            <Col className="content">
                <Title>
                    سرمایه گذاری ها
                </Title>
                <ChartContainer xl={20}>
                    <Col xl={8}>
                        {itemConfig.map((each, index) => {
                            return (
                                <Item
                                    onClick={() => {
                                        setSelected(each.id)
                                        setSelected_sub(1)
                                    }}
                                >
                                    <Col className={each.id === selected ? "btn active" : "btn"}>
                                        {each.title}
                                    </Col>
                                    {each.id === selected &&
                                        <ArrowLeftIcon />
                                    }
                                </Item>
                            )
                        })}
                    </Col>
                    <Col xl={8}>
                        {(itemConfig.find((each) => each.id === selected).sub).map((each, index) => {
                            return (
                                <Item
                                    onClick={() => setSelected_sub(each.id)}
                                >
                                    <Col className={each.id === selected_sub ? "btn active" : "btn"}>
                                        {each.title}
                                    </Col>
                                    {each.sub.length !== 0 && each.id === selected_sub &&
                                        <ArrowLeftIcon />
                                    }
                                </Item>
                            )
                        })}
                    </Col>
                    <Col xl={8}>
                        {((itemConfig.find((each) => each.id === selected).sub).find((each) => each.id === selected_sub)).sub.map((each, index) => {
                            return (
                                <Item>
                                    <a href={routPath.investmentDetails}>
                                        <Col className="btn">
                                            {each.title}
                                        </Col>
                                    </a>
                                </Item>
                            )
                        })}
                    </Col>
                </ChartContainer>
            </Col>
        </Wrapper>
    )
}

export default Investment;